import { useQuery } from './useQuery'

export const usePageQuery = (): number | null => {
  const page = useQuery().get('page')
  const parsedPageNumber = page ? parseInt(page) : null

  if (parsedPageNumber && parsedPageNumber < 1) {
    return 1
  }
  return page ? parseInt(page) : null
}
